//resets form data
export var resetForm = () => {
	if (location.href.indexOf('#reset') < 0) {
		window.location.href = location.href + '#reset';
	}
	location.reload();
};
